/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowModel } from './ShowModel';
import { ShowModelFromJSON, ShowModelFromJSONTyped, ShowModelToJSON } from './ShowModel';

/**
 *
 * @export
 * @interface ListShowResponse
 */
export interface ListShowResponse {
    /**
     *
     * @type {number}
     * @memberof ListShowResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListShowResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListShowResponse
     */
    total: number;
    /**
     *
     * @type {Array<ShowModel>}
     * @memberof ListShowResponse
     */
    shows: Array<ShowModel>;
}

/**
 * Check if a given object implements the ListShowResponse interface.
 */
export function instanceOfListShowResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('shows' in value)) return false;
    return true;
}

export function ListShowResponseFromJSON(json: any): ListShowResponse {
    return ListShowResponseFromJSONTyped(json, false);
}

export function ListShowResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListShowResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        shows: (json['shows'] as Array<any>).map(ShowModelFromJSON),
    };
}

export function ListShowResponseToJSON(value?: ListShowResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        shows: (value['shows'] as Array<any>).map(ShowModelToJSON),
    };
}
